import type { LoginFormValues } from '~/schema/login-form-schema'
import { getLoginFormSchema } from '~/schema/login-form-schema'

export { getLoginFormSchema }
export type { LoginFormValues }

export type PostLoginRequest = LoginFormValues

const DEFAULT_INITIAL_VALUES: LoginFormValues = {
  email: '',
  password: '',
}

export function getInitialDefaultValues({
  defaultInitialValues,
}: {
  defaultInitialValues?: Partial<LoginFormValues>
}): Partial<LoginFormValues> {
  return {
    ...DEFAULT_INITIAL_VALUES,
    ...defaultInitialValues,
  }
}
